<script setup lang="ts">
import { inject } from 'vue'
import type { ConfigData } from '@/types'
import { useLocationStore } from '@/stores/useLocationStore'

const locationStore = useLocationStore()
const gmrConfig = inject<ConfigData>('gmrConfig')

</script>

<template>
  <Transition name="result-fade">
    <div v-show="locationStore.resultData && locationStore.resultData.data.length > 0" class="result-container">
      <div class="result-table-wrapper">
        <table class="result-table">
          <thead>
            <tr>
              <th colspan="3" class="result-table-title">
                <h2>{{ gmrConfig?.tableTitle }}</h2>
              </th>
            </tr>
            <tr v-if="locationStore.resultData && locationStore.resultData.data.length > 0" class="result-table-header-subtitle">
              <th v-for="(item, index) in locationStore.resultData.data" :key="item.year_cycle + '_' + index">
                {{ item.cycle_year }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="locationStore.resultData && locationStore.resultData.data.length > 0" >
              <td v-for="(item, index) in locationStore.resultData.data" :key="item.year_cycle + '_' + index">
                {{ item.cycle_month }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="info-text" v-html="gmrConfig?.infoText"></div>
    </div>
  </Transition>
</template>

<style scoped>
.result-fade-enter-active,
.result-fade-leave-active {
  transition:
    opacity 0.4s ease,
    transform 0.4s ease,
    max-height 0.4s ease;
  overflow: hidden;
}

.result-fade-enter-from,
.result-fade-leave-to {
  opacity: 0;
  max-height: 0;
}

.result-fade-enter-to,
.result-fade-leave-from {
  max-height: 600px;
}

.result-container {
  margin-top: 1rem;
  table tr:hover {
    background-color: unset!important;
  }
}

.result-table tr th,
.result-table tr td {
  text-align: center;
  padding: 0.75rem;
}



.result-table-title h2 {
  text-align: center;
  font-weight: 400;
  font-size: 1.4rem;
}

.result-table-header-subtitle {
    th {
        background-color: rgba(242,242,242, 0.5) !important;
    }
}

.info-text {
  margin-top: 1.5rem;
 text-align: justify;
}


</style>
